module.exports = __webpack_public_path__ + "assets/images/CPLogo.5dc26.png";